import { useAppMutation } from './useAppMutation';

interface EnrolmentRequestBody {
  // Exactly one is sent: courseId for a Ceventas course, integrationCourseId for an own-LMS course.
  courseId?: string;
  integrationCourseId?: string;
}

export const useRequestCourseEnrolment = () => {
  const { mutate, isPending } = useAppMutation<unknown, Error, EnrolmentRequestBody>(
    'post',
    '/CourseEnrolmentRequest'
  );

  const onRequestEnrolment = (
    id: string,
    options?: {
      // Own-LMS (2nd-LearnUpon) course — send integrationCourseId instead of courseId.
      isIntegrationCourse?: boolean;
      onSuccess?: () => void;
      onError?: (error: Error) => void;
    }
  ) => {
    const body: EnrolmentRequestBody = options?.isIntegrationCourse
      ? { integrationCourseId: id }
      : { courseId: id };
    mutate(body, options);
  };

  return { onRequestEnrolment, isPending };
};
